import { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { PersonalMessages } from '../../../_lib/components/PersonalMessages';

export const WatchedPageMessagesDefaultView = asView(PersonalMessages);
export type WatchedPageMessagesDefaultView = ComponentProps<typeof WatchedPageMessagesDefaultView>;
